import React from "react";
import { Table } from "antd";
import Utils from "../../../../utility/Utils";

const Auditreport = ({ tableData, loading }) => {
  const columns = [
    {
      title: "User Name",
      dataIndex: "audit_user_name",
      key: "audit_user_name",
      width: 200,
    },
    {
      title: "User IP",
      dataIndex: "audit_user_ip",
      key: "audit_user_ip",
      width: 200,
    },
    {
      title: "Time",
      dataIndex: "audit_time",
      key: "audit_time",
      width: 150,
      render: (text, record) => {
        return text ? Utils.istTime(text) : "NA";
      },
    },
    {
      title: "Browser",
      dataIndex: "audit_browser",
      key: "audit_browser",
      width: 200,
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={tableData}
      className="report-table"
      pagination={{ defaultPageSize: 50 }}
      rowKey="uniqueKey"
      size="small"
      scroll={{ y: "60vh" }}
      loading={loading}
    />
  );
};

export default Auditreport;
